import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=869bba6c&scoped=true&"
import script from "./ProjectDetails.vue?vue&type=script&lang=ts&"
export * from "./ProjectDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDetails.vue?vue&type=style&index=0&id=869bba6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869bba6c",
  null
  
)

export default component.exports